// 无人机飞行参数设置
export default {
    ET: 'Тип оборудования',
    PSDT: 'Пожалуйста, выберите тип устройства',
    RP: 'Прочитать параметры',
    WP: 'Записать параметры',
    SP: 'Сохранить параметры',
    OP: 'Открытые параметры',
    NS: 'Пожалуйста, введите имя дрона/SN',
    ND: 'Нет данных',
    FP: 'Параметры полета',
    CUPN: 'Имя используемого в настоящее время параметра',
    CUPT: 'Используемый в настоящее время тип параметра',
    explain: 'Описание',
    control: 'управлять; управление',
    value: 'значение',
    RCS: 'Чувствительность дистанционного управления',
    PS: 'Вид контроля',
    PN: 'название параметра',
    PD: 'Описание параметра',
    PF: 'Файл параметров',
    TIME: 'время',
    AVL: 'кольцо угловой скорости',
    AR: 'Угловое кольцо',
    HR: 'Кольцо высоты',
    PR: 'Кольцо местоположения',
    AA: 'Ускорение по высоте',
    AV: 'Высотная скорость',
    altitude: 'высота',
    PS1: 'Скорость позиционирования',
    position: 'должность',
    MAJ: 'Максимальное ускорение',
    TCSOS: 'Поза в момент гребка соответствует скорости',
    MinA: 'Минимальное ускорение',
    TMAAV: 'Минимально допустимое значение ускорения при ударе по джойстику или торможении в режиме фиксированной точки. Эффект: небольшой ход, чтобы соответствовать скорости.',
    MaxA: 'Максимальное ускорение',
    TMAAV2: 'Максимально допустимое значение ускорения при ударе по джойстику или торможении в режиме фиксированной точки. Эффект такой: следите за скоростью большого количества ударов.',
    MaxS: 'Максимальная скорость',
    MAS: 'Максимально допустимая скорость',
    MSORC: 'Максимальная скорость дистанционного управления',
    MARCS: 'Максимально допустимая скорость дистанционного управления',
    VF: 'Фильтр скорости',
    AFASF: 'После уменьшения частоты среза фильтра скорости самолет становится мясистым (не включается)',
    ACF: 'Флаг управления ускорением',
    ACHT: 'Время зависания управления ускорением',
    MAV: 'Максимальная разница в ускорении',
    tip_PCOV: 'Пожалуйста, отметьте дрон',
    tip_PSDT: 'Пожалуйста, выберите тип устройства',
    tip_PCTU: 'Пожалуйста, отметьте дрон',
    tip_TPCUA: 'Используемые в настоящее время параметры несовместимы с моделью, и есть риск для безопасности при принудительной записи. Вы хотите написать?',
    tip_DP: 'Удалить параметр',
    tip_PEPR: 'Ошибка параметра, введите заново',
    tip_PSE: 'Ошибка установки параметра',
    tip_UTRAD: 'Невозможно восстановить после удаления, вы хотите продолжить?',
}